import{useDashboardQuery}from'./use-dashboard-query';/**
 * Hook for querying spaces data from BigQuery
 * @param tenantIds - Optional array of tenant IDs to filter spaces, empty array = all tenants
 */export function useSpacesQuery(tenantIds){const filterClause=tenantIds&&tenantIds.length>0?`AND s.organizationId IN (${tenantIds.map(id=>`'${id}'`).join(', ')})`:'';const sql=`
    SELECT 
      s.id,
      s.displayName,
      s.organizationId,
      COALESCE(t.displayName, t.organizationName) as tenantName,
      CAST(s.latitude AS FLOAT64) as latitude,
      CAST(s.longitude AS FLOAT64) as longitude,
      s.address,
      s.city,
      s.country
    FROM \`phydatacentral.space\` s
    INNER JOIN \`phydatacentral.tenant\` t ON s.organizationId = t.id
    WHERE s.type = 'location'
      AND s.latitude IS NOT NULL
      AND s.longitude IS NOT NULL
      AND t.id != '5cbac8a388e174147b878cdd'
      AND COALESCE(t.parentOrganizationId, '') != '5cbac8a388e174147b878cdd'
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ${filterClause}
    ORDER BY COALESCE(t.displayName, t.organizationName), s.displayName
  `;const queryKey=tenantIds&&tenantIds.length>0?['spaces-map',...tenantIds.sort()]:['spaces-map','all'];return useDashboardQuery(queryKey,sql);}/**
 * Hook for querying all tenants for filter dropdown
 */export function useTenantsForFilter(){const sql=`
    SELECT DISTINCT
      t.id as tenantId,
      t.organizationName as tenantName,
      t.displayName
    FROM \`phydatacentral.tenant\` t
    INNER JOIN \`phydatacentral.space\` s ON t.id = s.organizationId
    WHERE t.id != '5cbac8a388e174147b878cdd'
      AND COALESCE(t.parentOrganizationId, '') != '5cbac8a388e174147b878cdd'
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      AND s.type = 'location'
    ORDER BY COALESCE(t.displayName, t.organizationName)
  `;return useDashboardQuery(['tenants-with-spaces'],sql);}